import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55c8411d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=55c8411d&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=55c8411d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8411d",
  null
  
)

export default component.exports